import React, { useState, useEffect } from "react";
import { BlackAndWhite } from "../../../../../../themes/Colors";
import DisplayButton from "../display-button/DisplayButton";
import { ItemDisplayCard } from "../../../stat-card/components";

const InventoryDashboard = ({ setLoading, admin }) => {
  const [productStats, setProductStats] = useState(null);
  const GetProductStats = async () => {
    try {
      const response = await fetch(
        "https://budloungedatabase.onrender.com/admin/getproductsStats",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id: admin.userId,
          }),
        }
      );

      const responseData = await response.json();
      if (!responseData.error && !responseData.accessDenied) {
        setLoading(false);
        setProductStats(responseData.categoryFilteredList);
      }
    } catch (err) {
      setLoading(false);
    }
  };

  useEffect(() => {
    GetProductStats();
  }, []);
  return (
    <div
      style={{
        width: "100%",
        flex: 1,

        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        flexDirection: "column",
        backgroundColor: BlackAndWhite.red50,
        overflowY: "scroll",
        overflowX: "hidden",
      }}
    >
      <div style={{ width: "100%", marginBottom: 10 }}>
        <div
          style={{
            marginLeft: 20,
            marginTop: 20,
            marginBottom: 10,
            fontSize: 18,
            fontWeight: "bold",
          }}
        >
          DASHBOARD
        </div>
      </div>
      <div
        style={{
          flexWrap: "wrap",
          width: "95%",
          padding: 10,
          display: "flex",
          // backgroundColor: BlackAndWhite.secondary,
          justifyContent: "center",
          // borderStyle: "solid",
          // WebkitBoxShadow: "0px 0px 7px 2px #00000030",
        }}
      >
        {productStats ? (
          productStats.map((items, index) => {
            return (
              <div key={index} style={{ padding: 20 }}>
                <ItemDisplayCard
                  title={items.categoryName}
                  value={items.categoryAmount}
                  height={100}
                />
              </div>
            );
          })
        ) : (
          <div>LOADING</div>
        )}
      </div>

      <div style={{ marginTop: 60 }}>
        <div>
          Here we can place a product search or more stats depending on your
          requirements
        </div>
      </div>
    </div>
  );
};

export default InventoryDashboard;
